import { Injectable } from '@angular/core';
import { AdvancedSearchResult } from 'src/app/models/advancedSearchResult';

@Injectable({
  providedIn: 'root'
})
export class AdvancedSearchStore {

  // searchParams: AdvancedSearchResult;
  // records: AdvancedSearchResult[];
  // sortedRecords: AdvancedSearchResult[];
  // totalRecords: number;
  // dropDownValues: {[key: string]: string };
  autocompleteValues: {[key: string]: string };
  visibleAutocompleteValues: {[key: string]: string };

  constructor() {
    // this.records = [];
    // this.sortedRecords = [];
    // this.dropDownValues = {};
  }

  // load(records: AdvancedSearchResult[]) {
  //   this.records = records;
  //   this.sortedRecords = this.records.slice();
  // }
}
